import { SVGProps } from 'react';

const UserMinus = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2m20-10h-6m-3-4a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    />
  </svg>
);
export default UserMinus;
